export enum Suit {
  Swords, Stars, Coins, Glyphs
}
